import { Grid, Fab, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
// 5888
import { Field, FieldArray, useFormikContext } from "formik";
//5889

import { TextField } from "formik-mui";
import React from "react";
import AddIcon from "@mui/icons-material/Add";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import IconButton from "@mui/material/IconButton";

import MoreInfo from "../MaterialComponents/MoreInfo";

const PREFIX = "ExternalPages";

const classes = {
  fab: `${PREFIX}-fab`,
  extendedIcon: `${PREFIX}-extendedIcon`,
  iconButton: `${PREFIX}-iconButton`,
  webPageURL: `${PREFIX}-webPageURL`,
};

const StyledFieldArray = styled(FieldArray)(({ theme }) => ({
  [`& .${classes.fab}`]: {
    margin: theme.spacing(3, 0),
  },

  [`& .${classes.extendedIcon}`]: {
    marginRight: theme.spacing(1),
  },

  [`& .${classes.iconButton}`]: {
    position: "relative",
    right: theme.spacing(1),
  },

  [`& .${classes.webPageURL}`]: {
    marginTop: "8px",
  },
}));

const quick_step_list = {
  type: "external",
  url: "",
  insert_parameter: "",
};

const ExternalPages = () => {
  const { values, isSubmitting } = useFormikContext();

  return (
    // is this still valid 5888
    <StyledFieldArray name="quick_step_list">
      {({ push, remove }) => (
        <>
          <Grid
            alignContent="flex-end"
            container
            wrap="nowrap"
            justifyContent="space-between"
            item
            xs={12}
          >
            <Grid>
              <Typography variant="h6" >
                External Pages
              </Typography>
              <Typography variant="subtitle1" >
                Please enter the study page URL.
              </Typography>
            </Grid>

            <MoreInfo
              outerContainerClassName="cacheSetup"
              popupArray={[
                "Study page URL: Web page you want the panelist to browse.",
              ]}
            />
          </Grid>
          {values.quick_step_list.map((_, index) => (
            <Grid
              key={index}
              item
              spacing={2}
              container
              justifyContent="flex-end"
            >
              <Grid item className={classes.webPageURL} xs={1}>
                {index === 0 ? (
                  ""
                ) : (
                  <IconButton
                    className={classes.iconButton}
                    disabled={isSubmitting}
                    onClick={() => remove(index)}
                    size="large"
                  >
                    <HighlightOffIcon color="primary" />
                  </IconButton>
                )}
              </Grid>
              <Grid
                className={classes.webPageURL}
                container
                wrap="nowrap"
                item
                xs={11}
              >
                <Typography
                  component={"span"}
                  style={{ marginRight: "8px", marginTop: "13px" }}
                  variant="body1"
                >{`${index + 1}.`}</Typography>
                <Field
                  variant="filled"
                  fullWidth
                  name={`quick_step_list.${index}.url`}
                  component={TextField}
                  label="Study page URL"
                />
              </Grid>
            </Grid>
          ))}
          <Grid
            className={classes.fab}
            container
            justifyContent="center"
            item
            xs={12}
          >
            <Fab
              variant="extended"
              size="medium"
              color="primary"
              aria-label="add"
              disabled={isSubmitting}
              onClick={() => push(quick_step_list)}
              type="button"
            >
              <AddIcon className={classes.extendedIcon} />
              Add Another Page
            </Fab>
          </Grid>
        </>
      )}
    </StyledFieldArray>
  );
};

export default ExternalPages;
